(function () {
  'use strict';

  angular.module('app').component('creditPaymentTermsPage', creditPaymentTermListCtrl());

  function creditPaymentTermListCtrl() {
    return {
      bindings: {},
      controller: CreditPaymentTermListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/credit-payment-terms/credit-payment-terms-page.component.html',
    };
  }

  CreditPaymentTermListCtrl.$inject = [
    'UtilService',
    'CreditPaymentTermService',
    'LanguageService',
  ];

  function CreditPaymentTermListCtrl(UtilService, CreditPaymentTermService, LanguageService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    // TODO: pending
    vm.permissions = {
      canCreate: true, //Ability.can('create_creditpaymentterm_accountadmin')
    };

    // Methods
    vm.createCreditPaymentTerm = createCreditPaymentTerm;
    vm.onShowCreditPaymentTerm = onShowCreditPaymentTerm;

    // Initializers
    getAdditionalLanguages();

    function getCreditPaymentTerms(selectedItem) {
      vm.filterCriteria = CreditPaymentTermService.getFilterCriteria();
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      CreditPaymentTermService.getCreditPaymentTerms(vm.filterCriteria).then(function (data) {
        vm.creditPaymentTerms = data;

        vm.totalItems = vm.creditPaymentTerms.length;

        vm.loadingItems = false;

        if (selectedItem) {
          vm.UtilService.itemListChanged(selectedItem.id);
        }
      });
    }

    function createCreditPaymentTerm() {
      if (!vm.permissions.canCreate) {
        return;
      }

      CreditPaymentTermService.openCreditPaymentTermModal(
        {},
        vm.defaultLanguage,
        vm.additionalLanguages,
        'create',
        getCreditPaymentTerms
      );
    }

    function onShowCreditPaymentTerm(creditPaymentTerm, mode) {
      CreditPaymentTermService.openCreditPaymentTermModal(
        creditPaymentTerm,
        vm.defaultLanguage,
        vm.additionalLanguages,
        mode
      );
    }

    function getAdditionalLanguages() {
      LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
        let languages = data.items;

        vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
        vm.additionalLanguages = languages.filter((language) => !language.is_default);

        getCreditPaymentTerms('');
      });
    }
  }
})();
